// src/components/BackButton.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import { getActiveRole, targetPathForRole } from '../utils/auth';
import { useTranslation } from 'react-i18next';
import { useSafeNavigate } from '../context/UnsavedChangesContext';

const BackButton = ({ label, className = '', to = null }) => {
    const { t } = useTranslation();
    const navigate = useSafeNavigate();
    const location = useLocation();

    const handleClick = () => {
        if (to) {
            navigate(to);
            return;
        }

        const from = location.state?.from ?? location.state?.returnTo;
        if (typeof from === 'string' && from.startsWith('/')) {
            navigate(from);
            return;
        }

        // Only history-back when this isn't the first SPA entry (deep link / new tab).
        if (location.key && location.key !== 'default') {
            navigate(-1);
            return;
        }

        navigate(targetPathForRole(getActiveRole()));
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            className={`inline-flex items-center gap-2 rounded-2xl border border-white/70 bg-white/85 px-4 py-2.5 text-sm font-semibold text-slate-700 shadow-[0_10px_25px_rgba(15,23,42,0.08)] backdrop-blur-sm transition-all duration-200 hover:-translate-y-0.5 hover:border-primary-200 hover:text-primary-700 hover:shadow-[0_14px_30px_rgba(15,23,42,0.12)] focus:outline-none focus:ring-4 focus:ring-primary-100 ${className}`}
        >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            {label ?? t('common.back')}
        </button>
    );
};

export default BackButton;
